export default __webpack_public_path__ + "static/desk-img-29e325656fab1c1819d4b51bcad6bfea.png";